import { Pipe, PipeTransform, inject } from '@angular/core';
import { MessageSenderUnion } from '@airgram/web';
import { from, Observable, of } from 'rxjs';
import { TelegramMessengerService } from '@src/app/modules/telegram';
import { UserService } from '@src/core/services';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'senderFullName',
})
export class SenderFullNamePipe implements PipeTransform {
  private readonly userService = inject(UserService);
  private readonly messengerService = inject(TelegramMessengerService);
  private readonly translateService = inject(TranslateService);

  transform(senderId?: number | MessageSenderUnion): Observable<string> {
    if (!senderId) return of(this.translateService.instant('common.labels.user'));

    if (typeof senderId !== 'number') {
      senderId = senderId._ === 'messageSenderChat' ? senderId.chatId : senderId.userId;
    }

    if (senderId > 0) {
      return from(this.userService.getUserFullName(senderId));
    }

    return from(this.messengerService.api.getChatTitle(senderId));
  }
}
